import React from 'react';
import { CheckCircleIcon, ClockIcon, UserIcon, BarChart2Icon } from 'lucide-react';
export function CommitmentsSection() {
  const commitments = [{
    title: 'Implement Eedi in intervention classes',
    description: 'Fully integrate Eedi as a core teaching tool across all randomly assigned intervention classes, following recommended practices and making use of all platform features for one academic year.',
    icon: <CheckCircleIcon className="w-6 h-6 text-green-500" data-id="element-158" />
  }, {
    title: 'Administer assessments',
    description: 'Administer baseline, midline, and endline STAR maths assessments under exam conditions to track progress throughout the study.',
    icon: <BarChart2Icon className="w-6 h-6 text-blue-500" data-id="element-159" />
  }, {
    title: 'Designate a lead teacher',
    description: 'Designate a lead teacher within school to coordinate participation and liaise with the Eedi team throughout the research study.',
    icon: <UserIcon className="w-6 h-6 text-purple-500" data-id="element-160" />
  }, {
    title: 'Time commitment',
    description: 'Allow approximately 20-30 minutes per week for Eedi activities in intervention classes, plus three 30-minute STAR assessment periods during the year.',
    icon: <ClockIcon className="w-6 h-6 text-orange-500" data-id="element-161" />
  }];
  return <section className="py-20 bg-gray-50" data-id="element-162">
      <div className="container mx-auto px-4" data-id="element-163">
        <div className="max-w-4xl mx-auto" data-id="element-164">
          <div className="inline-flex items-center px-3 py-1.5 bg-blue-100 rounded-full mb-4" data-id="element-165">
            <span className="text-blue-700 font-medium" data-id="element-166">
              Participation Requirements
            </span>
          </div>
          <h2 className="text-3xl font-bold mb-4" data-id="element-167">
            🤝 What We Ask From Schools
          </h2>
          <div className="w-16 h-1 bg-gradient-to-r from-purple-500 to-blue-500 mb-6" data-id="element-168"></div>
          <p className="text-lg text-gray-700 mb-10 max-w-3xl" data-id="element-169">
            To take part, schools will need to:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-170">
            {commitments.map((commitment, index) => <div key={index} className="bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1" data-id="element-171">
                <div className="flex items-start" data-id="element-172">
                  <div className="mr-4 mt-1 flex-shrink-0" data-id="element-173">
                    {commitment.icon}
                  </div>
                  <div data-id="element-174">
                    <h3 className="font-bold text-lg mb-2 text-gray-800" data-id="element-175">
                      {commitment.title}
                    </h3>
                    <p className="text-gray-700" data-id="element-176">{commitment.description}</p>
                  </div>
                </div>
              </div>)}
          </div>
          {/* Callout box */}
          <div className="mt-10 bg-white rounded-xl shadow-md p-6 border-l-4 border-green-500" data-id="element-177">
            <div className="flex items-start" data-id="element-178">
              <div className="mr-4 mt-1" data-id="element-179">
                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center" data-id="element-180">
                  <span className="text-xl" data-id="element-181">✓</span>
                </div>
              </div>
              <div data-id="element-182">
                <h3 className="font-bold text-lg mb-2 text-gray-800" data-id="element-183">
                  No financial cost to participate
                </h3>
                <p className="text-gray-700" data-id="element-184">
                  There is no cost to join the study. In fact, your school will
                  receive financial compensation and free access to premium
                  tools worth thousands of pounds.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}